import { useCallback, useRef } from "react";
import styled from "styled-components";
import {
  TemplatePreview,
  TemplatePreviewProps,
} from "pages/media/components/storyboardEditor/components/Template/TemplatePreview";

export const TemplatePreviewWithVideoControls = (
  props: TemplatePreviewProps
) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  const wrapperRefCallback = useCallback((wrapper: HTMLDivElement | null) => {
    if (!wrapper) return;

    const attachTo = (video: HTMLVideoElement) => {
      videoRef.current = video;
      video.muted = true;
    };

    const existing = wrapper.querySelector("video");
    if (existing) attachTo(existing);

    const observer = new MutationObserver(() => {
      const current = wrapper.querySelector("video");
      if (current && current !== videoRef.current) {
        attachTo(current);
      } else if (!current) {
        videoRef.current = null;
      }
    });
    observer.observe(wrapper, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      videoRef.current = null;
    };
  }, []);

  const handleMouseEnter = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    video.play().catch((error) => {
      console.error("Error playing preview video", error);
    });
  }, []);

  const handleMouseLeave = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    video.pause();
    video.currentTime = 0;
  }, []);

  return (
    <Wrapper
      ref={wrapperRefCallback}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <TemplatePreview {...props} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: inline-block;

  &,
  * {
    cursor: default !important;
  }
`;
